import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren, DoCheck,
  ElementRef, EventEmitter, HostListener,
  Input, IterableDiffers, OnChanges,
  OnInit, Output,
  QueryList,
  Renderer2, SimpleChanges,
  ViewChild
} from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatColumnDef, MatHeaderCellDef, MatHeaderRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { TdoTableColumnComponent } from './tdo-table-column/tdo-table-column.component';
import { MatSort } from '@angular/material/sort';
import { TdoTableSelectionEvent } from './models/tdo-table-selection.event';
import { TdoSearchEvent } from '../tdo-search/models/TdoSearchEvent';
import { TdoSearchComponent } from '../tdo-search/tdo-search.component';
import { MatPaginator } from '@angular/material/paginator';
import { TdoTableRowModel } from './models/tdo-table-row.model';
import { TdoTableFooterDataModel } from './models/tdo-table-footer-data.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'tdo-table',
  templateUrl: './tdo-table-v2.component.html',
  styleUrls: ['./tdo-table-v2.component.scss']
})
export class TdoTableV2Component implements OnInit, AfterViewInit, OnChanges {
  @Input() dataSource: any[];
  @Input() footerData: TdoTableFooterDataModel[]; 
  @Input() displayedColumns: string[];
  @Input() height = 200;

  @Input() sortActive: string;
  @Input() sortDirection = null;

  @Input() isShowHeadersIfNoData = false;
  @Input() isStickyHeader = true;
  @Input() isSelectable = true;
  @Input() isMultiSelection = false;
  @Input() isAutoSelectFirstItem = false;
  @Input() isSearchable = true;
  @Input() isUsePaginator = false;
  @Input() isDragAndDrop = false;
  @Input() isDragAndDropHiddenXOverflow = false;
  @Input() isAddButtonEnabled = false;
  @Input() HasRowNumbers = false;
  @Input() pageSizeOptions = undefined; 
  @Input() pageSize = 30;
  @Input() flatSource: any[] = [];
  @Input() searchPredicate: (data: any, filter: string) => boolean;
  @Input() sortPredicate: (item: any, property: string) => string;
  @Input() label = '';
  @Input() searchInputValue = '';
  @Input() cypressControlAddButtonIdentifier: string = 'cypressControlAddButtonIdentifier';
  @Input() cypressControlIdentifier: string = 'tdo-table';
  @Input() noDataMessage:string = 'No data available.';

  @Output() rowSelected = new EventEmitter<TdoTableSelectionEvent>();
  @Output() rowContextMenu = new EventEmitter<TdoTableSelectionEvent>();
  @Output() rowsReordered = new EventEmitter<void>();
  @Output() addClicked = new EventEmitter<void>();
  @Output() tableRenderComplete = new EventEmitter<void>();   // will work on v16+

  

  @ContentChildren(TdoTableColumnComponent) tdoColumns: QueryList<TdoTableColumnComponent>;
  @ViewChild(TdoSearchComponent) searchView: TdoSearchComponent;

  @ViewChild('table') table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('parent') parentView: ElementRef;
  @ViewChild('paginatorView') paginatorView: ElementRef;

  matDataSource: MatTableDataSource<any>;
  selectionControl: SelectionModel<any>;
  isReady = false;

  sortChange(e): void {
    // save cookie with table sort data here
  }

  constructor(private cdr: ChangeDetectorRef) {
    //
  }

  /* getTableHeight(): number {
     return this.parentView?.nativeElement?.getBoundingClientRect().height - this.searchView?.viewHeight - this.paginatorView?.nativeElement.getBoundingClientRect().height;
   }*/

  ngOnInit(): void {
console.log('tdo-table-v2 component initialized: ', this.isUsePaginator, this.pageSize, this.pageSizeOptions);
  }

  onRowSelected(event, row ): void {

    const isSelectedAlready = this.selectionControl.isSelected(row);

    if (this.isSelectable) {
      if (this.selectionControl.isMultipleSelection()) {
        this.selectionControl.toggle(row);
      } else {
        if (this.selectionControl.isSelected(row))
          this.selectionControl.deselect(row);
        else
          this.selectionControl.select(row);
      }

      const model = new TdoTableSelectionEvent();
      model.isSelected = this.selectionControl.isSelected(row);

      model.row = row;
      model.model = row.model;
      model.isMultiSelection = this.isMultiSelection;
      if (model.isMultiSelection) {
        model.allSelectedRows = this.selectionControl.selected;
      }

      if (this.selectionControl.isMultipleSelection()) {
        this.rowSelected.emit(model);
      } else {
          this.rowSelected.emit(model);
      }
    }
  }

  onRowContextMenu(event, row): void {
    const model = new TdoTableSelectionEvent();
    model.row = row;
    model.model = row.model;
    model.mouseEvent = event;
    this.rowContextMenu.emit(model);
  }

  ngAfterViewInit(): void {
    this.flatSource = [];
    this.displayedColumns = [];
    this.selectionControl = new SelectionModel<any>(this.isMultiSelection, []);
    if( this.HasRowNumbers){
      this.dataSource.forEach((item, index) => {
        item['rowNumber'] = index + 1;
      });
    }

    this.updateData();

    this.isReady = true;

    // if initial search string was passed in
    if (this.searchInputValue) {
      const searchEvent = new TdoSearchEvent(this.searchInputValue);
      this.applySearchFilter(searchEvent);
    }
    this.cdr.detectChanges();

  }

  updateData(newArr: any = null): void {
    if ((!this.dataSource && !newArr) || !this.tdoColumns) {
      return null;
    }

    let src: any[];
    if (newArr) {
      src = newArr;
      this.dataSource = src;
    } else {
      src = this.dataSource;
    }

    if (this.isShowHeadersIfNoData) {
      for (const item of this.tdoColumns) {
        if (!this.displayedColumns.includes(item.propertyName)) {
          this.displayedColumns.push(item.propertyName);
        }
      }
    }

    this.flatSource = [];
    for (const model of src) {
      const obj = new TdoTableRowModel();
      for (const item of this.tdoColumns) {

        if (!this.displayedColumns.includes(item.propertyName)) {
          this.displayedColumns.push(item.propertyName);
        }
        if (!item.targetObjectName) {
          obj[item.propertyName] = model[item.propertyName];
        } 
        else {
          const arr = item.targetObjectName.split('.');

          let deepObject: object = model[arr[0]];
          arr.splice(0, 1);

          for (const str of arr) {
            deepObject = deepObject[str];
          }

          try {
            obj[item.propertyName] = deepObject[item.propertyName];
          } catch (e) {
            obj[item.propertyName] = '';
          }
        }
      }
      obj.model = model;
      obj.index = this.flatSource.length;

      this.flatSource.push(obj);
    }
    if (!this.matDataSource) {
      this.matDataSource = new MatTableDataSource<any>(this.flatSource);
      if (this.sortPredicate) {
        this.matDataSource.sortingDataAccessor = this.sortPredicate;
      } else {
        this.matDataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
          const colDef = this.tdoColumns.find(c=> c.propertyName === sortHeaderId);
          if (colDef?.dataType === "datetime"){
            return (new Date(data[sortHeaderId])).getTime().toString();
          }
          else if (typeof data[sortHeaderId] === 'string') {
            return data[sortHeaderId].toLocaleLowerCase();
          }          
          return data[sortHeaderId];
        };
      }
      if (this.matDataSource.data.length > 0) {
        console.log('tdo-table-v2 component data source initialized: ', this.matDataSource.data.length, this.isUsePaginator, this.paginator);
        this.matDataSource.sort = this.sort;
        this.sort.active = this.sortActive;
        this.sort.direction = this.sortDirection;
        if (this.paginator && this.isUsePaginator) {
          this.matDataSource.paginator = this.paginator;
        }

        if (this.isAutoSelectFirstItem) {
          const model = new TdoTableSelectionEvent();
          model.isSelected = this.selectionControl.isSelected(this.matDataSource.data[0]);

          model.row = this.matDataSource.data[0];
          model.model = this.matDataSource.data[0].model;
          model.isMultiSelection = this.isMultiSelection;
          if (model.isMultiSelection) {
            model.allSelectedRows = this.selectionControl.selected;
          }

          this.selectionControl.select(model);
          this.rowSelected.emit(model);
        }
      }
    } else {
      setTimeout(() => {
        this.matDataSource.data = this.flatSource;
        this.matDataSource._updateChangeSubscription();

        const lastSelected = this.matDataSource.data.find(p => p === this.selectionControl.selected[0]);
        if (lastSelected) {
          this.selectionControl.select(lastSelected);
        } else {
          if (this.isAutoSelectFirstItem) {
            this.selectionControl.select(this.matDataSource.data[0]);
          }
        }
      }, 1);
    }    
  }

  applySearchFilter(event: TdoSearchEvent): void {
    if (!event.value) {
      this.searchInputValue = '';
    } else {
      this.searchInputValue = event.value;
    }

    if (this.searchPredicate) {
      this.matDataSource.filterPredicate = this.searchPredicate;
    }

    this.matDataSource.filter = this.searchInputValue.toLowerCase();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource) {
      if (this.flatSource) {
        this.updateData();
      }
    }
  }

  onDropRow(event: CdkDragDrop<MatTableDataSource<any>, any>) {
    if (!this.isDragAndDrop) {
      return;
    }

    this.matDataSource.sort = null;
    const prevIndex = this.matDataSource.data.findIndex((d) => d === event.item.data);
    moveItemInArray(this.matDataSource.data, prevIndex, event.currentIndex);
    this.table.renderRows();
    this.rowsReordered.emit();
  }

  onAddClick(event: MouseEvent) {
    this.addClicked.emit();
  }



  onTableContentChanged() {
    this.tableRenderComplete.emit()
  }


  setSelectedModel(row: any) {
    if (this.matDataSource) {
      const ro = this.matDataSource.data.find(p => p.model === row);
      if (ro) {
        this.selectionControl.select(ro);
      }
    }
  }

  deselectAll() {
    this.selectionControl.deselect(this.selectionControl.selected);
    this.updateData();
  }

  selectRowNumber(index:number) {
    if (this.matDataSource) {
      this.selectionControl.select(this.matDataSource.data[index]);
    }
  }
}
